export default {
  amount: {
    id: 'rm_metal_smartphone_quantity',
    defaultMessage: 'Smartphone quantity:',
  },
} as const
